import { useState, useCallback, useEffect } from "react";
import { TextField, Button } from "@mui/material";
import styles from "./AddFamilyMemberModal.module.css";
import localStyles from "./ChangeTraderPasswordModal.module.css";

const initialForm = { password: "", password2: "" };

function ChangeTraderPasswordModal({ isOpen, trader, onClose, onSubmit }) {
  const [form, setForm] = useState(initialForm);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      setForm(initialForm);
      setError("");
    }
  }, [isOpen, trader?.id]);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setError("");
  }, []);

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      if (!form.password) {
        setError("Password is required.");
        return;
      }
      if (form.password !== form.password2) {
        setError("Passwords do not match.");
        return;
      }
      try {
        await onSubmit(trader.id, { password: form.password, password2: form.password2 });
        setForm(initialForm);
        setError("");
        onClose();
      } catch (err) {
        setError(err?.response?.data?.detail || "Failed to change password");
      }
    },
    [form, trader, onSubmit, onClose]
  );

  const handleClose = useCallback(() => {
    setForm(initialForm);
    setError("");
    onClose();
  }, [onClose]);

  if (!isOpen || !trader) return null;

  const label = trader.full_name || trader.email || `Trader #${trader.id}`;

  return (
    <div className={styles.overlay} onClick={handleClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2 className={styles.title}>Change password</h2>
          <button type="button" className={styles.closeBtn} onClick={handleClose} aria-label="Close">
            <svg className={styles.closeIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <p className={localStyles.subtitle}>{label}</p>
          {error && <p className={styles.error}>{error}</p>}

          <div className={styles.sectionBlock}>
            <div className={styles.grid}>
              <div className={styles.field}>
                <label className={styles.label}>New password</label>
                <TextField
                  name="password"
                  type="password"
                  value={form.password}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  className={styles.input}
                  variant="outlined"
                  autoComplete="new-password"
                />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Confirm password</label>
                <TextField
                  name="password2"
                  type="password"
                  value={form.password2}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  className={styles.input}
                  variant="outlined"
                  autoComplete="new-password"
                />
              </div>
            </div>
          </div>

          <div className={styles.actions}>
            <Button type="button" variant="outlined" onClick={handleClose} className={styles.cancelBtn}>
              Cancel
            </Button>
            <Button type="submit" variant="contained" className={styles.submitBtn}>
              Update password
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ChangeTraderPasswordModal;
